import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setRedirectUri } from '../redux/actions/auth';
import { event } from '../redux/actions/google';
import Alerts from '../prototypes/Alerts';
import EtelAPI from '../api/EtelAPI';

/* Navigation Component */
import {
  Navbar,
  NavbarImageItem,
  MenuItem
} from './Navigation';

class LoginBar extends React.Component {
  constructor( props ){
    super( props );
    this.onLogoff = this.onLogoff.bind( this );
    this.onHome = this.onHome.bind( this );
    this.onViewProfile = this.onViewProfile.bind( this );
    this.onResetPassword = this.onResetPassword.bind( this );
    this.onApiDocumentation = this.onApiDocumentation.bind( this );
  }

  onHome( e ) {
    const { dispatch } = this.props;
    dispatch( setRedirectUri( '/home' ) );
    const history = this.props.history;
    if( history !== undefined ) {
      history.push( '/home' );
    }
  }

  onViewProfile( e ) {
    const { dispatch } = this.props;
    dispatch( setRedirectUri( '/user/profile' ) );
    const history = this.props.history;
    if( history !== undefined ) {
      history.push( '/user/profile' );
    }
  }

  clearUserInfo = ( ) => {
    if( (localStorage !== null) && (localStorage !== undefined ) ) {
      localStorage.removeItem('id_token');
      localStorage.removeItem('id_token_expires');
      localStorage.removeItem('etel.displayname');
    };
  }

  getIdToken = ( ) => {
    if( (localStorage !== null) && (localStorage !== undefined ) ) {
      return localStorage.getItem('id_token');
    };
    return null;
  }

  getExpiresAt = ( ) => {
    if( (localStorage !== null) && (localStorage !== undefined ) ) {
      return localStorage.getItem('id_token_expires');
    };
    return null;
  }

  getDisplayName = ( ) => {
    if( (localStorage !== null) && (localStorage !== undefined ) ) {
      return localStorage.getItem('etel.displayname');
    };
    return 'Unknown User';
  }

  gotoLogin = ( ) => {
    const { history } = this.props;
    history.push('/login');
  };

  onLogoff( e ) {
    const { dispatch } = this.props;
    const idToken = this.getIdToken();
    if( idToken ) {
      const displayName = this.getDisplayName();
      dispatch( event( 'User Menu','User Event', 'SIGN OFF - ' + displayName ) );
      this.clearUserInfo();
      const api = new EtelAPI('logoff');
      api.logoff( idToken ).then( response => {
        this.gotoLogin();
      }).catch( exeption => {
        this.gotoLogin();
      });
    } 
  }

  onResetPassword( e ) {
    const auth = this.props.auth;
    const user = this.props.user;
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const profile = auth.getProfile( user );
    const api = new EtelAPI( 'auth/users' );
    const alerts = new Alerts( bugsnag, dispatch );

    api.passwordreset( { EMAIL: profile.email } ).then( ( result ) => {
      alerts.SUCCESS( 'Reset Password Request', 'Successfully sent password request. An e-mail was sent to ' + profile.email + '.', 5000 );
    } ).catch( ( exception ) => {
      alerts.CRITICAL( 'Reset Password Request', exception );
    } );
  }

  onApiDocumentation( e ) {
    const { dispatch } = this.props;
    dispatch( setRedirectUri( '/docs/api' ) );
    const history = this.props.history;
    if( history !== undefined ) {
      history.push( '/docs/api' );
    }
  }

  getProfile() {
    const auth = this.props.auth;
    const user = this.props.user;
    const currentprofile = auth.getProfile( user );

    let profile = {
      name: '',
      picture: '',
      email: '',
    };

    if( currentprofile !== undefined ) {
      if( currentprofile.api !== -1 ) {
        if( currentprofile.name !== '' ) {
          profile.name = currentprofile.nickname;
        } 
      }

      profile.picture = currentprofile.picture;
    }
    
    return profile;
  }

  render(){
    const auth = this.props.auth;
    if( auth !== undefined ){
      if( auth.loggedIn() === true ) {
        const profile = this.getProfile();
        if( ( profile !== undefined ) && ( profile !== null ) ) {
          if( localStorage !== undefined && localStorage !== null ) {
            if( profile.name !== '' ) {
              localStorage.setItem('etel.displayname', profile.name );  
            }
          }
          return (
            <span className="login-bar">
              <Navbar>
                <NavbarImageItem caption={profile.name} image={profile.picture} textCase='capitalize' >
                  <MenuItem caption="Home" route="/home" onClick={this.onHome} />
                  <MenuItem caption="View Profile" onClick={this.onViewProfile} />
                  <MenuItem caption="Reset Password" onClick={this.onResetPassword} />
                  <hr />
                  <MenuItem caption="API Documentation" onClick={this.onApiDocumentation} />
                  <hr />
                  <MenuItem caption="Log Out" onClick={this.onLogoff} />
                </NavbarImageItem>
              </Navbar>
            </span>
          );
        }
      }
    }
    return( <span></span> );
  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag,
        user: store.user.user,
        google: store.google.ReactGA
      };
    }
  )( LoginBar ) );



// WEBPACK FOOTER //
// ./src/presentation/LoginBar.js